import React from 'react';
import AlcoholManagement from './AlcoholManagement';
import { useTranslation } from 'react-i18next';

const Alcohol: React.FC = () => {
  const { t } = useTranslation('dashboard');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title.title')}</h6>
      <div className="bg-white rounded-md p-4">
        <AlcoholManagement />
      </div>
    </section>
  );
};

export default Alcohol;